import { colorPool } from "@/module/service-configs-module/statistics-visualization-module/first-svetofor/util";
import {
  COLORS,
  round,
} from "@/module/service-configs-module/statistics-visualization-module/stat-diversity/utils";
import { PlayerStatsDto } from "@/shared/api";

const hexToArgbDecimal = (hex: string) => {
  hex = hex.replace(/^#/, "");

  if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  if (hex.length === 4)
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];

  // Разберем HEX на компоненты
  let a = 255; // значение по умолчанию для альфа-канала
  let r, g, b;

  if (hex.length === 8) {
    // Если есть альфа-канал (8 символов)
    a = parseInt(hex.substring(0, 2), 16);
    r = parseInt(hex.substring(2, 4), 16);
    g = parseInt(hex.substring(4, 6), 16);
    b = parseInt(hex.substring(6, 8), 16);
  } else if (hex.length === 6) {
    // Без альфа-канала (6 символов)
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    throw new Error("Неверный формат HEX. Используйте #RGB, #RGBA, #RRGGBB или #RRGGBBAA");
  }

  // Соберем компоненты в ARGB формате и конвертируем в decimal
  // Формат: 0xAARRGGBB
  const argb = (a << 24) | (r << 16) | (g << 8) | b;

  // Преобразуем в беззнаковое 32-битное число
  return argb >>> 0;
};

export type SciChartPoint = {
  x: number;
  y: number;
  z: number;
  meta: {
    pid: string;
    aiProfile: string;
    pointScale: number;
    vertexColor: number;
    xName: string;
    yName: string;
    zName: string;
    color: string;
  };
};

export const createChartData = (
  data: PlayerStatsDto[],
  statNames: {
    x: string;
    y: string;
    z: string;
  },
  axisNames: {
    x: string;
    y: string;
    z: string;
  }
) => {
  return data.map((item) => {
    let hexColor = COLORS.hero;

    if (item.ai_profile === "") {
      if (item.total_bb_profit >= 0) {
        hexColor = COLORS.winner;
      } else {
        hexColor = COLORS.loser;
      }
    }

    const x = item.stats[statNames.x];
    const y = item.stats[statNames.y];
    const z = item.stats[statNames.z];

    return {
      x: x ? round(x) : 0,
      y: y ? round(y) : 0,
      z: y ? round(z) : 0,
      meta: {
        pid: item.player_id,
        aiProfile: item.ai_profile,
        pointScale: 0.75,
        vertexColor: hexToArgbDecimal(hexColor),
        xName: axisNames.x || "",
        yName: axisNames.y || "",
        zName: axisNames.z || "",
        color: hexColor,
      },
    };
  });
};
